module.exports = __webpack_public_path__ + "img/6.0dbe09d5.jpg";